import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBoxProps {
  initialValue?: string;
  size?: 'sm' | 'lg';
  placeholder?: string;
  className?: string;
}

export default function SearchBox({
  initialValue = '',
  size = 'sm',
  placeholder = '搜索漫画、作者或关键词…',
  className = '',
}: SearchBoxProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const kw = value.trim();
    if (!kw) return;
    navigate(`/search?q=${encodeURIComponent(kw)}`);
  };

  const isLarge = size === 'lg';

  return (
    <form onSubmit={handleSubmit} role="search" className={className}>
      <div
        className={`flex items-center gap-2 bg-background-100 border border-background-300 rounded-full pl-4 pr-1 ${
          isLarge ? 'h-12 md:h-14' : 'h-10'
        } focus-within:border-primary-400 transition-colors`}
      >
        <i className={`ri-search-line text-foreground-500 ${isLarge ? 'text-xl' : 'text-base'}`}></i>
        <input
          type="search"
          name="q"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          aria-label="站内搜索"
          className={`flex-1 min-w-0 bg-transparent outline-none text-foreground-900 placeholder:text-foreground-400 ${
            isLarge ? 'text-base' : 'text-sm'
          }`}
        />
        <button
          type="submit"
          className={`shrink-0 rounded-full bg-primary-500 text-background-50 font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap ${
            isLarge ? 'px-5 md:px-7 h-10 md:h-12 text-sm md:text-base' : 'px-4 h-8 text-sm'
          }`}
        >
          搜索
        </button>
      </div>
    </form>
  );
}